import './App.css';
import { LoginRegisterWrapper } from './LoginRegister/components/loginRegisterWrapper';
import { SCR_COMPETITION, SCR_OVERVIEW, SCR_PROFILE, GET_COUNTRIES, GET_NATIONALITIES, SCR_PROFILE_UPDATED, SCR_VIEW_ENTRY } from './enums';
import { connect } from 'react-redux';
import OverviewTable from './Overview/overviewTable';
import CompetitionTabsWrapper from './Competition/components/competitionTabsWrapper';
import { useEffect, useState } from 'react';
import TopMenu from './Navigation/topMenu';
import { Profile } from './profile/profile';
import axios from 'axios';
import { ProfileUpdated } from './profile/profileUpdated';
import ViewEntry from './Overview/viewEntry';
//import http from './http';
//import { AUTH_REFRSH, API_LOGOUT } from './enums';


// import { setCurrentPage } from './Navigation/currentPage';
// import { setCompetitionTab } from './Navigation/currentTab';

// import { setLoggedInUser } from './LoginRegister/reducers/loginState';

function App({loggedInUser, dispatch, currentPage}) {
  
  const [countries, setCountries] = useState([]);
  const [nationalities, setNationalities] = useState([]);
  //const [build] = useState('Build 03072024 15:50');

  // useEffect(() => {
  //   console.info(build);
  // }, [build])

  //debug only
  useEffect(() => {
    // async function refresh() {
    //   const result = await http.post(AUTH_REFRSH).catch((error) => console.log(error));
      
    //   if (!result) {
    //     await axios.get(API_LOGOUT);
    //   }
    // }
    // if (Object.keys(loggedInUser).length === 0) {
    //   refresh();
    // }
    // dispatch(setCurrentPage(SCR_COMPETITION));
    // dispatch(setLoggedInUser({ name: 'test', email: 'email@example.com'}));
    // dispatch(setCompetitionTab(TAB_ENTRY_SUBMITTED));
  }, [loggedInUser])


  useEffect(() => {

    async function fetchOptions() {
      let countries = await axios.get(GET_COUNTRIES);
      let nationalities = await axios.get(GET_NATIONALITIES);

      setCountries(countries.data.data);
      setNationalities(nationalities.data.data);
      window.country_options = countries.data.data;
    }

    fetchOptions();

  }, [])

  const currentPageIs = (page) => {
    return currentPage === page;
  }

  return (
    <div className='app w-full'>
      <div className='min-h-6'>
        {loggedInUser.name && <TopMenu />}
      </div>
      {!loggedInUser.name && <LoginRegisterWrapper dispatch={dispatch} countries={countries} nationalities={nationalities} />}
      
      {(loggedInUser.name) &&
        <div className='logged-in-area'>
        
        {/* only shown if we are logged in or just registered
        if logged in, show the overview, if registered, show the category screen */}

        {currentPageIs(SCR_OVERVIEW) && <OverviewTable />}

        {currentPageIs(SCR_COMPETITION) && <CompetitionTabsWrapper />}

        {currentPageIs(SCR_PROFILE) && <Profile dispatch={dispatch} countries={countries} nationalities={nationalities} loggedInUser={loggedInUser} />}

        {currentPageIs(SCR_PROFILE_UPDATED) && <ProfileUpdated dispatch={dispatch} />}

        {currentPageIs(SCR_VIEW_ENTRY) && <ViewEntry />}

      </div>}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    loggedInUser: state.loginState,
    currentPage: state.navigationState
  }
}

export default connect(mapStateToProps)(App);